import React, { useState, useEffect } from "react";
import "./style.css";
import { Row, Col } from "antd";
import plana_53 from "../../image/plana_53.png";
import plana_40 from "../../image/plana_40.JPG";
import Logo1920 from "../../image/Lowboy Ramiro Petrolero (2).png";
import Logo19202 from "../../image/tchange.jpg";
import lowboytsa2025 from "../../image/IMG_2831.JPG";

import Logo2020 from "../../image/Lowboy Saxum Petrolero (3).png";
import Logo2121 from "../../image/tisapower.jpg";
import Footer from "../FooterComponent";
import { useDispatch } from "react-redux";
import { updateProductsState } from "../../store/profile";
import NavbarComponent from "../NavbarComponent";
import { useSelector } from "react-redux";
import { checkCartIfExist } from "../../helper";
import { LoadingOutlined } from "@ant-design/icons";

function EighteenSection() {
  const dispatch = useDispatch();
  const { products } = useSelector((state) => state.profile);

  const [loading, setloading] = useState(false);
  const [hitUseEffect, sethitUseEffect] = useState(false);

  const handleLoading = () => {
    setloading(false);
  };

  useEffect(() => {
    setloading(true);

    setTimeout(handleLoading, 1000);
  }, [hitUseEffect, products]);
  return (
    <>
      <NavbarComponent />
      <div>
        <div className="border">
          <Row className="rowo1" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={Logo1920} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">RAMIRO PETROLERO 2021</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAMA UTIL</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">11.38 M</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">ANCHO CUCHILLA</h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">2.60M</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAPACIDAD DE CARGA</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">60 T</h6>
                  </div>
                </div>

                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">UNIDADES DISPONIBLES </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">1</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("RAMIRO PETROLERO 2021") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Low Boy",
                                  name: "RAMIRO PETROLERO 2021",
                                  cama_util: "11.38 M",
                                  ancho: "2.60 M",
                                  unidades_disponibles: "1",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo2" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={Logo2020} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">SAXUM PETROLERO 2022</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAMA UTIL</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">12 M</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">ANCHO </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">3.05M</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAPACIDAD DE CARGA</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">60 T</h6>
                  </div>
                </div>

                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">UNIDADES DISPONIBLES </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">1</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("SAXUM PETROLERO 2022") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Low Boy",
                                  name: "SAXUM PETROLERO 2022",
                                  cama_util: "12 M",
                                  ancho: "3.05M",
                                  unidades_disponibles: "1",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo1" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={Logo19202} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">TTSA LBD60-305 ABATIBLE 2023</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAMA UTIL</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">7 M</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">ANCHO </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">3.05 M</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAPACIDAD DE CARGA</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">60 T</h6>
                  </div>
                </div>

                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">UNIDADES DISPONIBLES </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">1</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("TTSA LBD60-305 ABATIBLE 2023") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Low Boy",
                                  name: "TTSA LBD60-305 ABATIBLE 2023",
                                  cama_util: "7 M",
                                  ancho: "3.05M",
                                  unidades_disponibles: "1",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo1" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={lowboytsa2025} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">TTSA LBD60-305 ABATIBLE 2025</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAMA UTIL</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">9 M</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">ANCHO </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">3.05 M</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAPACIDAD DE CARGA</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">60 T</h6>
                  </div>
                </div>

                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">UNIDADES DISPONIBLES </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">1</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("TTSA LBD60-305 ABATIBLE 2025") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Low Boy",
                                  name: "TTSA LBD60-305 ABATIBLE 2025",
                                  cama_util: "9 M",
                                  ancho: "3.05M",
                                  unidades_disponibles: "1",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo2" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={Logo2121} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">TTSA PAVER 305 53 2022</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAMA UTIL</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">10 M</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">ANCHO </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">3.05 M</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAPACIDAD DE CARGA</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">55 T</h6>
                  </div>
                </div>

                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">UNIDADES DISPONIBLES </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">1</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    <button className="btonficha">
                      <h6 className="ficha">FICHA TECNICA</h6>
                    </button>
                  </div>
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("TTSA PAVER 305 53 2022") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Low Boy",
                                  name: "TTSA PAVER 305 53 2022",
                                  cama_util: "10 M",
                                  ancho: "3.05M",
                                  unidades_disponibles: "1",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo2" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={plana_53} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">PLATAFORMA PLANA 53 FT</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAMA UTIL</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">15 M</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">ANCHO </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">2.6 M</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAPACIDAD DE CARGA</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">40 T</h6>
                  </div>
                </div>

                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">UNIDADES DISPONIBLES </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">1</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("PLATAFORMA PLANA 53 FT") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Low Boy",
                                  name: "PLATAFORMA PLANA 53 FT",
                                  cama_util: "15 M",
                                  ancho: "2.6M",
                                  unidades_disponibles: "1",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="rowo2" justify="space-between">
            <Col lg={12} md={24} xs={24}>
              <div>
                <img className="bus img-fluid" src={plana_40} alt="" />
              </div>
            </Col>
            <Col lg={9} md={24} xs={24}>
              <div className="divohol">
                <div className="divo">
                  <h6 className="dd13">PLATAFORMA PLANA 40 FT</h6>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAMA UTIL</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">12.20 M</h6>
                  </div>
                </div>
                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">ANCHO </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">2.6 M</h6>
                  </div>
                </div>
                <div className="potenhol">
                  <div>
                    <h6 className="poten">CAPACIDAD DE CARGA</h6>
                  </div>
                  <div className="power">
                    <h6 className="poten">30 T</h6>
                  </div>
                </div>

                <div className="potenhol1">
                  <div className="gray">
                    <h6 className="carga">UNIDADES DISPONIBLES </h6>
                  </div>
                  <div className="gray1">
                    <h6 className="poten">2</h6>
                  </div>
                </div>

                <div className="btonmng">
                  <div>
                    {loading ? (
                      <LoadingOutlined />
                    ) : (
                      <>
                        {checkCartIfExist("PLATAFORMA PLANA 40 FT") ? (
                          <p style={{ color: "green" }}>Added!</p>
                        ) : (
                          <button
                            className="btonficha1"
                            onClick={() => {
                              dispatch(
                                updateProductsState({
                                  class: "Low Boy",
                                  name: "PLATAFORMA PLANA 40 FT",
                                  cama_util: "12.20 M",
                                  ancho: "2.6M",
                                  unidades_disponibles: "1",
                                })
                              );

                              setloading(true);
                              sethitUseEffect(!hitUseEffect);
                            }}
                          >
                            <h6 className="ficha">AÑADIR A COTIZACIÓN</h6>
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EighteenSection;
